/* Shared test-id constants (kebab-case). */
export const HOME = { emergentLink: "home-emergent-link" };

export const AUTH = {
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  loginError: "login-error",
  logoutBtn: "logout-btn",
};

export const NAV = {
  dashboard: "nav-dashboard",
  donors: "nav-donors",
  donations: "nav-donations",
  schedules: "nav-schedules",
  followups: "nav-followups",
  communications: "nav-communications",
  reports: "nav-reports",
  settings: "nav-settings",
};

export const DASH = {
  kpiMonth: "kpi-month-total",
  kpiYear: "kpi-year-total",
  kpiPromised: "kpi-promised",
  kpiLate: "kpi-late",
  kpiActiveDonors: "kpi-active-donors",
  kpiFollowups: "kpi-followups",
  chartMonthly: "chart-monthly",
};

export const DONORS = {
  addBtn: "donor-add-btn",
  searchInput: "donor-search",
  typeFilter: "donor-type-filter",
  row: (id) => `donor-row-${id}`,
  saveBtn: "donor-save-btn",
  cancelBtn: "donor-cancel-btn",
  fieldFirstName: "donor-first-name",
  fieldLastName: "donor-last-name",
  fieldOrg: "donor-org-name",
  fieldEmail: "donor-email",
  fieldPhone: "donor-phone",
  fieldType: "donor-type",
};

export const PLEDGE = {
  addBtn: "pledge-add-btn",
  amount: "pledge-amount",
  frequency: "pledge-frequency",
  kind: "pledge-kind",
  startDate: "pledge-start-date",
  method: "pledge-method",
  saveBtn: "pledge-save-btn",
};

export const PAYMENT = {
  addBtn: "payment-add-btn",
  amount: "payment-amount",
  date: "payment-date",
  method: "payment-method",
  reference: "payment-reference",
  saveBtn: "payment-save-btn",
  uploadReceipt: "payment-upload-receipt",
};

export const NL = {
  createBtn: "newsletter-create-btn",
  name: "newsletter-name",
  subject: "newsletter-subject",
  segment: "newsletter-segment",
  html: "newsletter-html",
  sendNow: "newsletter-send-now",
  saveBtn: "newsletter-save-btn",
};
